import {Stoppage, StoppageCode, StoppageTypeWithCode} from '@hconnect/common/types'

export const getStoppageDescription = (
  item: Stoppage,
  stoppageCodes: {[key in StoppageTypeWithCode]: StoppageCode[]}
) => {
  if ('stoppageType' in item && 'stoppageCode' in item) {
    const {stoppageType, stoppageCode} = item
    const stoppage = stoppageCodes[stoppageType].find((item) => item.code === stoppageCode)
    return stoppage?.description
  }
  return null
}
